import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, take } from 'rxjs/operators';
import VALIDATE_EMAIL from './queries/validate-email';

@Injectable({
  providedIn: 'root',
})
export class UserEmailGraphqlService {
  constructor(private apollo: Apollo) {}
  getEmailValidation(emailAddress: string) {
    return this.apollo
      .use('user')
      .watchQuery<{ validateEmail: any }>({
        variables: { emailAddress },
        query: VALIDATE_EMAIL,
      })
      .valueChanges.pipe(
        take(1),
        map((request) => {
          return request.data.validateEmail;
        }),
      );
  }
}
